import type GetWeatherForecastResponse from 'owa-service/lib/contract/GetWeatherForecastResponse';
import type { WeatherForecast } from 'owa-graph-schema';
import convertOwsWeatherLocationToGqlWeatherData from './convertOwsWeatherLocationToGqlWeatherData';
import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';

export default function convertOwsWeatherForecastToGqlWeatherForecast(
    owsWeatherForecast: GetWeatherForecastResponse
): WeatherForecast {
    const weatherForecast: WeatherForecast = {
        weatherDataForLocations: owsWeatherForecast.WeatherLocations?.map(weatherLocation =>
            convertOwsWeatherLocationToGqlWeatherData(weatherLocation)
        ),
        pollingWindowInMinutes: owsWeatherForecast.PollingWindowInMinutes,
        temperatureUnit:
            owsWeatherForecast.TemperatureUnit == TemperatureUnit.Celsius
                ? 'Celsius'
                : 'Fahrenheit',
    };

    return weatherForecast;
}
